var _rect, _path, _circle, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualizeImbalanceOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#272D55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13L30.5263 29.5H11.4737L21 13Z",
    fill: "#E3ECFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 13,
    r: 3,
    fill: "#E3ECFF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.77639,
    y1: 20.0142,
    x2: 32.6995,
    y2: 7.55267,
    stroke: "#E3ECFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizeImbalanceOperationIcon);
export default __webpack_public_path__ + "static/media/VisualizeImbalanceOperationIcon.c638c8250427fa1097ed9e582100da40.svg";
export { ForwardRef as ReactComponent };